(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SoccerJersey", [], factory);
	else if(typeof exports === 'object')
		exports["SoccerJersey"] = factory();
	else
		root["SoccerJersey"] = factory();
})(self, () => {
return 